/* eslint-disable */

import * as THREE from 'three'

export default
{
    uniforms:
    {
        image: { type: 't', value: new THREE.Texture() },
        scale: { type: 'vec2', value: new THREE.Vector2() }
    },

    vertexShader: `
        varying vec2 vUv;

        void main()
        {
            vUv = uv;

            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
    `,

    fragmentShader: `
        uniform sampler2D image;
        uniform vec2 scale;
        uniform vec2 offset;
        uniform float alpha;
        uniform float hasAlphaImage;
        uniform sampler2D alphaImage;

        varying vec2 vUv;

        void main()
        {
            vec4 color = texture2D(image, vec2((vUv.x + offset.x) * scale.x + (1.0 - scale.x) * 0.5, (vUv.y + offset.y) * scale.y + (1.0 - scale.y) * 0.5));

            if(hasAlphaImage == 1.0)
            {
                vec4 alphaColor = texture2D(alphaImage, vec2(vUv.x * scale.x + (1.0 - scale.x) * 0.5, vUv.y * scale.y + (1.0 - scale.y) * 0.5));
                color.a = (alphaColor.r + alphaColor.g + alphaColor.b) / 3.0;

                // red = 0.34
                // green = 0.5
                // blue = 0.16
            }

            color.a *= alpha;

            gl_FragColor = color;
        }
    `
}


// WEBPACK FOOTER //
// ./src/scripts/components/page-home/Background/Shaders/Image.js